import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { customerDataAPI, tableAPI } from '../Component/API/API';
import Header from '../Component/sharedFiles/header/header';
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import { useNavigate } from 'react-router-dom';
import './stagesTable.css'
import { useDispatch, useSelector } from 'react-redux';
import { selectUser } from '../Component/ReduxStore/userReducer';
import { GetData } from '../Component/API/getApi';
import { TextField } from '@mui/material';

const StagesTable = () => {
    const [tablevalue, setTableValue] = useState([]);
    const [stageValue, setStageValue] = useState([]);
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");
    const [isDropdownVisible, setIsDropdownVisible] = useState(false);
    const [customerName, setCustomerName] = useState(null);
    const [CustomerCode, setCustomerCodes] = useState(null);
    const [customer, setCustomer] = useState([]);
    const userData = useSelector(selectUser);
    const dispatch = useDispatch();
    const databaseName = 'ZCH10092024';
    const jwtToken = 'dafds';
    const [customerCreation, setCustomerCreation] = useState([
        {
          customerName: "",
          customerCode:""
        },
      ]);
    // const tableAPI = "https://localhost:7225/api/CrmOpportunity/GetCrmOpporStage?DatabaseName=Live_TpTilesandSanitaries&OpprId=5536";

    useEffect(() => {
        // const fetchTable = async () => {
        //     try {
        //         const response = await axios.get(tableAPI)
        //         setTableValue(response.data.item4);
        //         setStageValue(response.data.item5);
        //         console.log("response :", response.data.item4);
        //     } catch (error) {
        //         console.error("Error fetching data:", error.message);
        //         if (error.response) {
        //             // The request was made and the server responded with a status code
        //             console.error("Response data:", error.response.data);
        //             console.error("Response status:", error.response.status);
        //             console.error("Response headers:", error.response.headers);
        //         } else if (error.request) {
        //             // The request was made but no response was received
        //             console.error("Request data:", error.request);
        //         } else {
        //             // Something happened in setting up the request that triggered an error
        //             console.error("Error message:", error.message);
        //         }
        //     }

        // }

        // fetchTable();
        GetCustomerData();
    }, [])

    
  //******** This is for get a customer data from API *********//
  const GetCustomerData = async () => {
    try {
      const customerData = await GetData(
        `${customerDataAPI}${databaseName}`,
        {
          headers: {
            wg_token: jwtToken,
          },
        },
        dispatch,
        navigate
      );
      setCustomer(customerData);
    } catch (error) {}
   
  };  
    const handleCustInputChange = (e) => {
        setSearchTerm(e.target.value);
      };
    
      //****** This will help to show the dropdown while click the input field *****/
      const handleInputClick = () => {
        setIsDropdownVisible(true);
      };
      //******* This will filter a customer data as per input values  ********/
      let filteredData = [];
      if (Array.isArray(customer) && searchTerm.length > 3) {
        filteredData = customer.filter(
          (item) =>
            (item.customerCode &&
              item.customerCode.toLowerCase().includes(searchTerm.toLowerCase())) ||
            (item.customerName &&
              item.customerName.toLowerCase().includes(searchTerm.toLowerCase()))
        );
      }
      //****** On final click on dropdown will get a customer name and customer code  ******/
      const handleItemClick = async (customerCode, customerName,phoneNum) => {
        setCustomerCodes(customerCode);
        setCustomerName(customerName);
        // setCustPhoneNum(phoneNum);
        setSearchTerm(`${customerCode}-${customerName}`);
        // setSearchTerm("");
        setCustomerCreation((prevCustomerCreation) => [
          {
            ...prevCustomerCreation[0],
            customerName: customerName,
            // PhoneNumber:phoneNum,
            customerCode:customerCode
          },
        ]);
        // dispatch(setCustomerCode({ customerCode: customerCode,
        //    customerName: customerName,
        //    phoneNum: phoneNum }));
        // setCustomerValue(true);
        setIsDropdownVisible(false);
      };
    const handleBackNav = () => {
        navigate("/DashBoard");
    };
    return (
        <>
            <Header />
            <div className="dashBoardMain">
                {/* <div className="dashImage"></div> */}
                <div className="dashGradient"></div>
                <div className='dashbordiv'>
                    <div className="backIconDiv">
                        <div className=" d-flex  align-items-center ">
                            <button onClick={handleBackNav} className="border-0 d-flex align-items-center">
                                <ArrowCircleLeftIcon />
                                <p className="DashBoardName col-xl-7 col-xxl-11 col-10 col-md-11">
                                    Dashboard
                                </p>
                            </button>
                        </div>
                    </div>
                    <div>
                        <div className="customerDiv col-6 col-xl-8">
                            <TextField
                                type="text"
                                label="Customer Name"
                                className="checkCust"
                                value={searchTerm || ""}
                                onClick={handleInputClick}
                                onChange={handleCustInputChange}
                                variant="standard"
                                autoComplete="off"
                            />
                            {isDropdownVisible && searchTerm && (
                                <ul className="binUl">
                                    {filteredData.map((item, index) => (
                                        <li
                                            key={index}
                                            onClick={() =>
                                                handleItemClick(item.customerCode, item.customerName, item.phoneNum)
                                            }
                                        >
                                            {item.customerCode}-{item.customerName}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default StagesTable;